module.exports = __webpack_public_path__ + "img/product_05.c71c0196.jpg";